import { FileText, MessageSquare, Users } from "lucide-react";
import { AUX_SERVICES } from "@/lib/company";

const ICONS = [FileText, MessageSquare, Users];

export default function AuxServices() {
  return (
    <section data-testid="aux-services" className="border-y border-slate-200 bg-slate-50/60">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex">Beyond training</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl text-slate-950">
            Certification is step one. Getting hired is where we shine.
          </h2>
          <p className="mt-4 text-slate-600 text-base leading-relaxed">
            Our alumni beat the market because we don&apos;t stop at the exam. From rewriting your resume to
            drilling behavioural rounds, our auxiliary services carry you across the finish line.
          </p>
        </div>
        <div className="lg:col-span-8 grid md:grid-cols-3 gap-6">
          {AUX_SERVICES.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={s.title}
                data-testid={`aux-service-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="border border-slate-200 bg-white p-6 hover:-translate-y-1 hover:shadow-lg transition-all"
              >
                <Icon className="w-8 h-8 text-[#0052FF]" />
                <h3 className="mt-6 font-display font-semibold text-xl text-slate-950">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
